export default __webpack_public_path__ + "static/media/1st-min.e3820e15.jpg";